import { render, staticRenderFns } from "./ReratedCoursesT.vue?vue&type=template&id=54996db7&"
import script from "./ReratedCoursesT.vue?vue&type=script&lang=js&"
export * from "./ReratedCoursesT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports